<template>
  <div class="bind-company-info" :style="warpperStyle">
    <div class="invoice_nav">
      <navbar
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.7rem'"
        :titlecolor="'#333'"
        @goback="goBack(false)"
      />
    </div>
    <div class="title">绑定企业支付宝账户</div>
    <div class="content">
      <div class="invoice_info van-clearfix">
        <p class="title">
          <span class="ww">账户</span>
          <span class="border"></span>
        </p>
        <div class="basic_info">
          <van-field
            v-model="value1"
            label="支付宝账户"
            format-trigger="onBlur"
            class="marTop12 licensse"
            placeholder="请输入您的手机号或邮箱"
          />
          <van-field
            v-model="value2"
            label="账户名称"
            format-trigger="onBlur"
            class="marTop12 licensse"
            placeholder="请输入企业支付宝的账户名"
            onkeyup="value=value.replace(/![u4e00-u9fa5]/ig,'')"
            onafterpaste="this.value=this.value.replace(/![u4e00-u9fa5]/ig,'')"
          />
          <van-field
            v-model="value3"
            label="手机号"
            class="marTop12 licensse"
            readonly
          />

          <van-field
            v-model="value4"
            label="验证码"
            format-trigger="onBlur"
            class="marTop12 licensse"
            placeholder="请输入验证码"
            type="number"
          >
            <template #button>
              <span @click="getvarify" :class="{ notap: notap }">{{
                verifyCon
              }}</span>
            </template>
          </van-field>
        </div>
      </div>
      <van-row class="explain">
        <van-col span="24" class="title">注意事项</van-col>
        <van-col span="24" class="con">
          <p>1.请确认支付宝账户与姓名填写正确，</p>
          <p>平台将对账户信息进行审核，审核通过后才可提现。</p>
        </van-col>
      </van-row>
    </div>
    <div class="complete" :style="completeStyle">
      <van-button @click="submit" type="primary" class="operation_btn"
        >提交</van-button
      >
      <div class="complete-empty"></div>
    </div>

    <div class="loading" v-if="loading">
      <img src="../../../assets/common/loading.gif" />
    </div>
  </div>
</template>

<script>
import navbar from "../components/nav-bar.vue";
export default {
  data() {
    return {
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      verifyCon: "获取验证码",
      getVerifyNum: 0,
      companyInfo: {},
      warpperStyle: { height: "100%" },
      completeStyle: { bottom: "0" },
      count: 0,
      loading: false,
      lefticon: require("@/assets/accountAgent/common/back.png"),
      notap: false,
    };
  },
  components: {
    navbar,
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.value3 = JSON.parse(
      localStorage.getItem("withdraw_info")
    ).supplier_tel;
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getvarify() {
      this.notap = true;
      if (this.getVerifyNum < 5) {
        this.getVerifyNum++;
        const _this = this;
        this.$api
          .post("/pushmsg/index/sms/send-code", {
            mobile: this.value3,
            type: 5,
          })
          .then((res) => {
            let down = 60;
            const timer = setInterval(function () {
              down--;
              _this.verifyCon = down + "s后重获";
              if (down <= 0) {
                _this.verifyCon = "获取验证码";
                clearInterval(timer);
                this.notap = false;
              }
            }, 1000);
            _this.$toast("验证码已发送，请注意查收");
          })
          .catch((err) => {
            this.notap = false;
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {
              this.$toast(message);
            }
          });
      } else {
        var current = Math.floor(new Date().getTime() / 1000);
        var tip = "";
        var stopGet = 0;
        if (this.getVerifyNum == 5) {
          this.getVerifyNum++;
          stopGet = current + 60 * 15;
          //        this.$toast('获取验证码次数已超过5次，请过15分钟之后再试。')
        }
        var ts = stopGet - current;
        var mm = Math.floor(ts / 60);
        var ss = ts - mm * 60;
        if (mm && ss) {
          tip =
            "获取验证码次数已超过5次，请过" + mm + "分钟" + ss + "秒之后再试。";
        } else if (mm && !ss) {
          tip = "获取验证码次数已超过5次，请过" + mm + "分钟之后再试。";
        } else if (!mm && ss) {
          tip = "获取验证码次数已超过5次，请过" + ss + "秒之后再试。";
        }

        this.$toast(tip);
      }
    },
    submit() {
      // 验证
      if (!this.value1) {
        this.$toast("请填写您的支付宝账号");
        return;
      } else if (!this.value2) {
        this.$toast("请输入企业支付宝的账户名");
        return;
      } else if (!this.value4) {
        this.$toast("请填写验证码");
        return;
      } else {
        this.confirm();
      }
    },
    confirm() {
      this.loading = true;
      const params = {
        account_number: this.value1,
        account_name: this.value2,
        code: this.value4,
        type: 1,
      };
      this.$api
        .post("member-relation/member/supplier/alipay/band", params)
        .then((data) => {
          this.$router.replace({
            path: "/purchaseSupplier/result",
            query: {
              type: 4,
            },
          });
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>


<style lang="less" scoped>
.bind-company-info {
  overflow-x: hidden;
  padding: 8.8rem 0 5rem;
  box-sizing: border-box;
  color: #333;
  font-size: 1.4rem;
  background: #f5f6f7;

  .invoice_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
  }
  .title {
    height: 6rem;
    line-height: 6rem;
    color: #333;
    font-size: 2rem;
    font-weight: 700;
    padding: 0 1.6rem;
  }
  .content {
    padding: 0 1.6rem;
    position: relative;

    .invoice_info {
      min-height: 27rem;
      background: #fff;
      border-radius: 0.8rem;
      padding: 0 1.6rem;
      box-sizing: border-box;

      .title {
        height: 5.4rem;
        color: #333;
        font-size: 1.6rem;
        font-weight: 700;
        position: relative;
        padding: 0;
        box-sizing: border-box;

        .ww {
          height: 2.2rem;
          line-height: 2.2rem;
          position: absolute;
          left: 0;
          top: 1.6rem;
          z-index: 1;
        }

        .border {
          width: 3.9rem;
          height: 0.4rem;
          display: inline-block;
          position: absolute;
          bottom: 1.8rem;
          left: 0;
          z-index: 0;
          background: -webkit-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Firefox 3.6 - 15 */
          background: linear-gradient(to right, #fc740c, #f41a3c);
        }
      }

      .van-cell {
        &::after {
          position: absolute;
          box-sizing: border-box;
          content: " ";
          pointer-events: none;
          right: 0;
          bottom: 0;
          left: 0 !important;
          border-bottom: 1px solid #ebedf0;
          -webkit-transform: scaleY(0.5);
          transform: scaleY(0.5);
        }
      }
      input::placeholder {
        color: #bababa;
        font-size: 14px;
      }
      /deep/.marTop12 {
        // margin-top: 12px;
        .van-field__control {
          font-size: 1.4rem;
          text-align: right;
        }

        .van-field__button {
          color: #5e9fff;
          font-size: 1.3rem;
          height: 1.6rem;
          line-height: 1.6rem;
          border-left: solid 1px #d8d8d8;
          padding-left: 0.7rem;
          margin-left: 0.7rem;
          width: 7.1rem;
          text-align: center;
        }
      }
      .basic_info {
        margin: 0;
        .van-cell {
          padding: 15px 0;
          &:not(:last-child)::after {
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            bottom: 0;
            left: 16px;
            border-bottom: 1px solid #ebedf0;
            -webkit-transform: scaleY(0.5);
            transform: scaleY(0.5);
          }
        }
        .van-field__label {
          font-size: 1.4rem;
          color: #333;
          font-weight: bold;
          width: 10.5rem;
          margin-right: 1.5rem;
        }
      }
    }

    .explain {
      .van-col {
        color: #999;
        font-size: 1.2rem;
        line-height: 1.8rem;
        margin-bottom: 2rem;
      }

      .title {
        color: #333;
        font-size: 1.4rem;
        font-weight: 700;
        height: 3.6rem;
        line-height: 3.6rem;
        margin: 0 0 0.4rem;
        padding: 0;
      }
    }
  }
  .complete {
    position: fixed;
    // bottom: 0;
    padding: 0 12px;
    // width: calc(100% - 24px);
    box-sizing: border-box;
    width: 100%;
    transition: bottom 0.1s linear;
    .complete-empty {
      height: 4px;
      width: 100%;
    }
    .operation_btn {
      color: #fff;
      border: none;
      width: 100%;
      margin: 0 auto;
      height: 44px;
      font-size: 16px;
      display: block;
      border-radius: 22px;
      line-height: 44px;
      font-weight: 600;
      background: -webkit-linear-gradient(to right, #fc740c, #f41a3c);
      /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(to right, #fc740c, #f41a3c);
      /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(to right, #fc740c, #f41a3c);
      /* Firefox 3.6 - 15 */
      background: linear-gradient(to right, #fc740c, #f41a3c);
    }
  }
  .van-uploader__preview-delet {
    font-size: 26px;
  }

  .tip {
    padding: 0 10px;
    text-align: left;
  }
  .tipL {
    margin-bottom: 24px;
  }
  .van-dialog__header {
    padding: 20px 0 24px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
  }

  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }

  .notap {
    pointer-events: none;
  }
}
</style>





